"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSObjectSyncStatus = void 0;
exports.allTakenFieldSets = allTakenFieldSets;
exports.createEmptyMapping = createEmptyMapping;
exports.isBlank = isBlank;
exports.mappingRowFingerprint = mappingRowFingerprint;
exports.mappingRowsFromBootstrap = mappingRowsFromBootstrap;
exports.mappingsMatchBaseline = mappingsMatchBaseline;
exports.nextId = nextId;
exports.objectLabelForDisplay = objectLabelForDisplay;
exports.parseDateTimeAsUTC = parseDateTimeAsUTC;
exports.rowListSelections = rowListSelections;
exports.shouldDisplayDropdownListUpwards = shouldDisplayDropdownListUpwards;
exports.syncStatusTooltipMessage = syncStatusTooltipMessage;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _dateFormatting = _interopRequireWildcard(require("@insided/shared/utils/dateFormatting"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CSObjectSyncStatus;
/** Single mapping row: CS Object → CS Attribute → CC Field */

exports.CSObjectSyncStatus = CSObjectSyncStatus;

(function (CSObjectSyncStatus) {
  CSObjectSyncStatus["PENDING"] = "PENDING";
  CSObjectSyncStatus["SUCCESS"] = "SUCCESS";
  CSObjectSyncStatus["FAILED"] = "FAILED";
  CSObjectSyncStatus["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
})(CSObjectSyncStatus || (exports.CSObjectSyncStatus = CSObjectSyncStatus = {}));

/** Matches `.control-dropdown__list { max-height }` in shared dropdown styles. */
var CONTROL_DROPDOWN_LIST_MAX_HEIGHT_PX = 400;
/** Format instant as `YYYY-MM-DD HH:mm` in UTC (e.g. `2026-02-20 21:37`). */

function formatUtcDateTimeYYYYMMDDHHmm(d) {
  d = new Date((0, _dateFormatting.default)(Math.trunc(new Date(d).getTime() / 1000)));
  return (0, _dateFormatting.formatLocalDateToSQL)(d);
}
/** Parse sync timestamps as UTC: `2026-04-06T07:05:03.577Z` or `2026-04-07 05:38:26.254435`. */


function parseDateTimeAsUTC(raw) {
  if (raw instanceof Date) return new Date(raw);
  var s = raw.trim();
  return new Date(s.includes(' ') ? "".concat(s.replace(' ', 'T'), "Z") : s);
}

function createEmptyMapping(id) {
  return {
    id: id,
    sourceObject: '',
    sourceField: '',
    targetField: '',
    lastSyncStatus: CSObjectSyncStatus.PENDING,
    lastSyncCompletedAt: new Date(),
    updatedAt: new Date().toISOString()
  };
}

function nextId() {
  return "mapping-".concat(crypto.randomUUID());
}
/** Global taken target fields and CS attribute keys (`sourceObject:sourceField`) across all rows. */


function allTakenFieldSets(mappings) {
  var takenTargetFields = new Set();
  var takenCsAttributes = new Set();

  var _iterator = _createForOfIteratorHelper(mappings),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var m = _step.value;
      if (m.targetField) takenTargetFields.add(m.targetField);
      if (m.sourceObject && m.sourceField) takenCsAttributes.add("".concat(m.sourceObject, ":").concat(m.sourceField));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    takenTargetFields: takenTargetFields,
    takenCsAttributes: takenCsAttributes
  };
}
/** Open upward when the list would overflow the viewport bottom and there is more room above. */


function shouldDisplayDropdownListUpwards(anchorEl) {
  var rect = anchorEl.getBoundingClientRect();
  var spaceBelow = window.innerHeight - rect.bottom;
  var spaceAbove = rect.top;
  return spaceBelow < CONTROL_DROPDOWN_LIST_MAX_HEIGHT_PX && spaceAbove > spaceBelow;
}

function mappingRowFingerprint(m) {
  return [m.sourceObject, m.sourceField, m.targetField].join('\0');
}
/** True when current rows are the same multiset as baseline (order ignored). */


function mappingsMatchBaseline(mappings, baseline) {
  if (mappings.length !== baseline.length) {
    return false;
  }

  var sort = function sort(keys) {
    return (0, _toConsumableArray2.default)(keys).sort(function (a, b) {
      return a.localeCompare(b);
    });
  };

  var a = sort(mappings.map(function (m) {
    return mappingRowFingerprint(m);
  }));
  var b = sort(baseline.map(function (m) {
    return mappingRowFingerprint(m);
  }));
  return a.every(function (k, i) {
    return k === b[i];
  });
}

function mappingRowsFromBootstrap(fields, syncStatus) {
  return fields.map(function (item) {
    return _objectSpread(_objectSpread({
      id: "mapping-".concat(item.sourceObject, "\0").concat(item.sourceField, "\0").concat(item.targetField)
    }, item), {}, {
      lastSyncStatus: syncStatus.lastSyncCompletedAt && parseDateTimeAsUTC(item.updatedAt) >= syncStatus.lastSyncCompletedAt ? CSObjectSyncStatus.PENDING : syncStatus.lastSyncStatus,
      lastSyncCompletedAt: syncStatus.lastSyncCompletedAt
    });
  });
}

function isBlank(value) {
  return value == null || String(value).trim() === '';
}
/** Underscores in object labels are shown as spaces in the UI. */


function objectLabelForDisplay(label) {
  return label.replace('_', ' ');
}
/**
 * CC and CS-attribute dropdown options for one row.
 * Accepts pre-computed global taken sets — call `allTakenFieldSets` once per render and pass the result here.
 * CS attribute keys in `globalTakenCsAttrs` must be `sourceObject:sourceField`.
 */


function rowListSelections(row, globalTakenTargets, globalTakenCsAttrs, ccFieldItems, ccFieldByValue, csAttributesForObject) {
  var ccFiltered = ccFieldItems.filter(function (item) {
    return item.value === row.targetField || !globalTakenTargets.has(item.value);
  });
  var ccOptionsForRow = ccFiltered;

  if (row.targetField && !ccOptionsForRow.some(function (item) {
    return item.value === row.targetField;
  })) {
    var _ccFieldByValue$get;

    ccOptionsForRow = [{
      title: (_ccFieldByValue$get = ccFieldByValue.get(row.targetField)) !== null && _ccFieldByValue$get !== void 0 ? _ccFieldByValue$get : row.targetField,
      value: row.targetField
    }].concat((0, _toConsumableArray2.default)(ccFiltered));
  }

  var rawCsAttrs = csAttributesForObject(row.sourceObject);
  var csAttrsFiltered = rawCsAttrs.filter(function (attr) {
    return attr.value === row.sourceField || !globalTakenCsAttrs.has("".concat(row.sourceObject, ":").concat(attr.value));
  });
  var csAttrsForRow = csAttrsFiltered;

  if (row.sourceField && !csAttrsForRow.some(function (attr) {
    return attr.value === row.sourceField;
  })) {
    var _row$dataType;

    csAttrsForRow = [{
      title: row.sourceField,
      value: row.sourceField,
      dataType: (_row$dataType = row.dataType) !== null && _row$dataType !== void 0 ? _row$dataType : 'string'
    }].concat((0, _toConsumableArray2.default)(csAttrsFiltered));
  }

  return {
    ccOptionsForRow: ccOptionsForRow,
    csAttrsForRow: csAttrsForRow
  };
}

function syncStatusTooltipMessage(status, lastSyncCompletedAt) {
  switch (status) {
    case CSObjectSyncStatus.PENDING:
      return 'Sync Pending';

    case CSObjectSyncStatus.SUCCESS:
      return lastSyncCompletedAt ? "Last sync: ".concat(formatUtcDateTimeYYYYMMDDHHmm(lastSyncCompletedAt)) : '';

    case CSObjectSyncStatus.FAILED:
      return 'Sync failed';

    case CSObjectSyncStatus.PARTIAL_SUCCESS:
      return lastSyncCompletedAt ? "Partial sync: ".concat(formatUtcDateTimeYYYYMMDDHHmm(lastSyncCompletedAt)) : '';

    default:
      return '';
  }
}